import * as R from 'ramda'

import { treeToDb } from 'src/lib/graph/walk'
import { pointConfigWithoutModifiersFragment } from 'src/lib/data/graphFragments'

export function clearCache(state, action) {
  const { path } = action.payload
  return R.dissocPath(path, state)
}

export const updateEarningRules = (state, action) => {
  const { boardId, gradingRules, txResponse } = action.payload

  const newPredicates = gradingRules.map((r, i) =>
    R.pipe(
      R.assoc(':db/id', txResponse[`temp-predicate-${i}`]),
      R.evolve({
        ':point-predicate/condition': conditions =>
          conditions.map((c, x) =>
            R.assoc(':db/id', txResponse[`temp-condition-${i}-${x}`], c)
          )
      })
    )(r)
  )

  const boardWithNewConfig = {
    ':db/id': boardId,
    ':board/point-configurations': [
      {
        ':db/id': txResponse['temp-point-config'],
        ':point-configuration/point-predicates': newPredicates,
        ':system/created-at': Date.now()
      }
    ]
  }

  const normalizedConfig = treeToDb(
    [
      ':db/id',
      {
        ':board/point-configurations': pointConfigWithoutModifiersFragment()
      }
    ],
    boardWithNewConfig
  )

  return R.mergeDeepRight(state, normalizedConfig)
}

export const setDisabledEmojis = (state, action) => {
  const { boardId, disabledEmojisJSON } = action.payload
  const disabledEmojisPath = [boardId, ':board/disabled-emojis']
  return R.assocPath(disabledEmojisPath, disabledEmojisJSON, state)
}

export const grantPoints = (state, action) => {
  const { userId, value } = action.payload
  const userPointsOnBoardPath = [userId, '@user/points-on-board']
  const userPointsOnBoard = R.path(userPointsOnBoardPath, state)

  return R.assocPath(
    userPointsOnBoardPath,
    userPointsOnBoard + parseInt(value),
    state
  )
}

export const updateIndividualUserMetrics = (state, action) => {
  const { value, userSquuid, boardId } = action.payload

  const userCappedTotalPath = [
    boardId,
    `user-${userSquuid}-metrics`,
    'cappedTotal'
  ]
  const userUncappedParticipationGradePath = [
    boardId,
    `user-${userSquuid}-metrics`,
    'uncappedParticipationGrade'
  ]
  if (R.hasPath([boardId, `user-${userSquuid}-metrics`], state)) {
    const cappedTotal = R.path(userCappedTotalPath, state) + parseInt(value)
    const scoreDenominator = R.path(
      [boardId, `user-${userSquuid}-metrics`, 'scoreDenominator'],
      state
    )
    const uncappedParticipationGrade = cappedTotal / scoreDenominator
    const assocCappedTotal = R.assocPath(
      userCappedTotalPath,
      cappedTotal,
      state
    )
    return R.assocPath(
      userUncappedParticipationGradePath,
      uncappedParticipationGrade,
      assocCappedTotal
    )
  }

  return state
}

export const removePinnedPost = (state, action) => {
  const { pinnedPostId, boardId } = action.payload

  const data = R.prepend(
    pinnedPostId,
    R.path([boardId, 'posts', 'data'], state)
  )

  return R.mergeDeepRight(state, {
    [boardId]: {
      '@board/pinned-to-top': null,
      posts: {
        data
      }
    }
  })
}
